import { message, Modal, Spin } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { resetPassword } from '../../apis/auth'
import ResetPasswordForm from '../Profile/ResetPassForm'
import { LogoWrapper, PassInnerWrapper, ResetPassWrapper } from './login.styled'
import useLogo from '../../hook/useLogo'

const ResetPassword = props => {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const { code } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const logo = useLogo()

  const handleModPass = async fieldsValue => {
    setIsLoading(true)
    const { newPassword } = fieldsValue
    const postData = { code, password: window.btoa(newPassword) }

    const result = await resetPassword(postData)
    if (result?.status === 200) {
      Modal.info({
        centered: true,
        icon: false,
        content: ln_t('message.success.resetPass'),
        onOk: () => { adminMode ? navigate('/admin/login') : navigate('/login') },
        okText: ln_t('util.confirm')
      })
    } else message.info(result?.data?.message || 'Server Error')
    setIsLoading(false)
  }

  return (
    <ResetPassWrapper>
      <PassInnerWrapper>
        <Spin spinning={isLoading}>
          <LogoWrapper onClick={() => adminMode ? navigate('/admin/login') : navigate('/login')}>
            {logo}
          </LogoWrapper>
          <ResetPasswordForm handleModPass={handleModPass} resetMode />
        </Spin>
      </PassInnerWrapper>
    </ResetPassWrapper>
  )
}

export default ResetPassword
